<template>
  <Aside>
    <h1>License / ID transactions</h1>
    <div>
      <p>You will receive your new card in the mail. Please allow two weeks for processing.</p>
    </div>

    <h1>Registration transactions</h1>
    <div>
      <p>
        Print the confirmation and receipt. This confirmation serves as your proof of transaction. 
        <br />
        You will receive a copy of the transaction documents at the email address you provided. 
        <br />
        This email will be from RI DMV Services 'ridmvservices-noreply@notification.dmv.ri.gov'. 
        <br />
        In case you don't see the email in your Inbox please check your spam folder. 
      </p>
    </div>
  </Aside>
</template>

<script>
import Aside from './Aside.vue';

export default {
  name: "AsideForUser",
  components: {
    Aside,
  },
}
</script>
